/**
 * Shared formatting utilities for the payment frontend.
 */

/**
 * Format a date string for admin screens — includes milliseconds.
 * Example: "Mar 23, 2026, 12:25:48.498 PM"
 */
export function formatDate(dateStr) {
  if (!dateStr) return '—';
  const d = new Date(dateStr);
  const base = d.toLocaleString('en-US', {
    month: 'short', day: 'numeric', year: 'numeric',
    hour: '2-digit', minute: '2-digit', second: '2-digit',
    hour12: true,
  });
  const ms = String(d.getMilliseconds()).padStart(3, '0');
  return `${base}.${ms}`;
}

/**
 * Format a date for customer-facing screens — no milliseconds, friendlier.
 * Example: "Mar 23, 2026"
 */
export function formatDateShort(dateStr) {
  if (!dateStr) return '—';
  return new Date(dateStr).toLocaleDateString('en-US', {
    year: 'numeric', month: 'short', day: 'numeric',
  });
}

/**
 * Format cents to dollar string, preserving the sign.
 * Example: 1900 → "$19.00", -1900 → "-$19.00"
 */
export function formatCents(cents) {
  if (cents == null) return '—';
  const negative = cents < 0;
  return `${negative ? '-' : ''}$${(Math.abs(cents) / 100).toFixed(2)}`;
}

/**
 * Shared subscription-status → MUI Chip color map.
 * Single source of truth so 'canceled', 'expired', etc. render
 * consistently across every screen.
 */
export const SUBSCRIPTION_STATUS_COLORS = {
  active: 'success',
  trialing: 'info',
  past_due: 'warning',
  paused: 'default',
  canceled: 'default',
  expired: 'default',
  admin_granted: 'secondary',
  pending: 'default',
};

/**
 * Look up the MUI Chip color for a subscription status.
 * Falls back to 'default' for unknown statuses.
 */
export function subscriptionStatusColor(status) {
  return SUBSCRIPTION_STATUS_COLORS[status] || 'default';
}
